export default __webpack_public_path__ + "static/media/marthoma.ebe39bcb.png";